import { Fragment, memo } from 'react';

import styles from './AuthModalTitle.module.css';

interface AuthModalTitleProps {
  title?: Nullable<string>;
}

function AuthModalTitle(props: AuthModalTitleProps) {
  const { title } = props;

  return (
    <Fragment>
      <span>Log In</span>

      {title && (
        <Fragment>
          <span> to </span>

          <span className={styles.highlightedTitle} aria-label="Auth subject title">{title}</span>
        </Fragment>
      )}
    </Fragment>
  );
}

export default memo(AuthModalTitle);
